export default {
  PHONE: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  ZIP_CODE: [/\d/, /\d/, /\d/, /\d/, /\d/],
  SSN_TAX_ID: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  CHECKING_ACCOUNT_NUMBER: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  YEAR: [/\d/, /\d/, /\d/, /\d/],
  LAST_FOUR_DIGITS: [/\d/, /\d/, /\d/, /\d/],
};
